export const capitalize=str=>{if(typeof str==="number")return str;return str.charAt(0).toUpperCase()+str.slice(1)};